import { render, staticRenderFns } from "./FormBaseSetting.vue?vue&type=template&id=00e5c2e9&scoped=true"
import script from "./FormBaseSetting.vue?vue&type=script&lang=js"
export * from "./FormBaseSetting.vue?vue&type=script&lang=js"
import style0 from "./FormBaseSetting.vue?vue&type=style&index=0&id=00e5c2e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e5c2e9",
  null
  
)

export default component.exports